// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab_tab__Gj2OK","active":"Tab_active__Ytn1Q"};